import { useEffect, useState } from 'react';
import type { SceneStore } from '@os/doc';
import { thumbnailPlan, worldObjects, type ThumbOp } from '../media/thumbnail';
import { ThumbOpsSvg } from '../media/ThumbOpsSvg';

/** A page's preview is redrawn at most this often while the board changes (a drag elsewhere costs nothing per frame). */
export const PAGE_THUMB_MS = 2000;

/** A page drawn small and static (P14 Ruling 12's cheap form, also the pages panel's vignette). */
export function PageThumb({ store, pageId, className }: { store: SceneStore; pageId: string; className?: string }) {
  const plan = () => thumbnailPlan(worldObjects(store, pageId));
  const [ops, setOps] = useState<ThumbOp[]>(plan);
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;
    setOps(plan());
    const off = store.subscribeList(() => {
      timer ??= setTimeout(() => {
        timer = null;
        setOps(plan());
      }, PAGE_THUMB_MS);
    });
    return () => {
      off();
      if (timer) clearTimeout(timer);
    };
  }, [store, pageId]);
  return <ThumbOpsSvg ops={ops} data-page-thumb={pageId} className={className} />;
}
